import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/timetracking',
        name: 'TimetrackingView',
        component: () => import(/* webpackChunkName: "timetracking" */ '@/modules/timetracking/components/TimetrackingView'),
        meta: {
            moduleId: 'timetracking',
            registries: ['configurations/timetracking'],
            preloads: ['rights/actingUserHasRight/WORK_Monat_Reisekostenabrechnung'],
        },
        props: true,
        beforeEnter: checkLinkedEmployee,
    },
    {
        path: '/overtime',
        name: 'OvertimeView',
        component: () => import(/* webpackChunkName: "overtime" */ '@/modules/timetracking/overtime/OvertimeView'),
        meta: {
            moduleId: 'overtime',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/overtime/:id',
        name: 'OvertimeForm',
        component: () => import(/* webpackChunkName: "overtime-form" */ '@/modules/timetracking/overtime/OvertimeForm'),
        meta: { moduleId: 'overtime' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/workingDayConfiguration',
        name: 'WorkingDayConfigurationView',
        component: () => import(/* webpackChunkName: "workingDayConfiguration" */ '@/modules/timetracking/working_day_configuration/components/WorkingDayConfigurationView'),
        meta: { 
            moduleId: 'workingDayConfiguration',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/workingDayConfiguration/:id',
        name: 'WorkingDayConfigurationForm',
        component: () => import(/* webpackChunkName: "workingDayConfigurationForm" */ '@/modules/timetracking/working_day_configuration/components/WorkingDayConfigurationForm'),
        meta: { moduleId: 'workingDayConfiguration' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
]
